import { css } from "lit";
import { Style } from "../Styles";

export default css`
    ${Style}

    :host {
        display: block;
    }

    .checkbox-grid {
        display: inline-grid;
        grid-template-columns: repeat(3, auto);
        grid-gap: 5px 10px;
    }

    h4 {
        margin-top: 0.75rem;
        margin-bottom: 0.5rem;
    }

    .clear-button {
        width: 100%;
    }

    .clear-button::part(base) {
        color: white;
    }

    .string-search {
        margin-top: 0.5em;
    }

    .editor-label,
    sl-select::part(form-control-label) {
        font-variant: all-petite-caps;
        font-weight: bold;
        font-size: larger;
    }

    sl-select::part(form-control-label) {
        margin-top: 0.75rem;
        margin-bottom: 0.5rem;
        font-weight: bold;
        font-size: 16px;
    }

    ds-fixed-panel {
        height: 100%;
    }

    .footer {
        flex-wrap: wrap;
        justify-content: space-evenly;
        padding-top: 0.5rem;
    }

    .footer sl-button {
        flex-grow: 1;
    }

    .body {
        display: flex;
        flex-direction: column;
        gap: 0.4em;
    }

    .advanced {
        padding: 0;
        padding-top: 0.5em;
    }

    .reset-button {
        justify-content: space-between;
        align-items: center;
    }

    sl-menu-item {
        background-color: white;
    }

    sl-details::part(base) {
        background-color: transparent;
        border: none;
    }

    sl-details::part(content) {
        padding: 0;
    }

    sl-details::part(header) {
        padding-left: 0;
        padding-right: 0;
    }

    sl-dropdown {
        width: 100%;
        flex: 1;
    }
`;
